<!-- TODO: remove debug helper once implementation is done -->
<!--<div class="row">-->
<!--    <div class="col" style="background-color: lightsalmon">-->
<!--        <strong>Functional element: {{(functionalElement$ | async)?.type}}</strong>-->
<!--    </div>-->
<!--</div>-->
<pace-forms-standard-functional-element
    *ngIf="isStandardFunctionalElement$ | async"
    [parentForm]="parentForm"
    [id]="id"
></pace-forms-standard-functional-element>
<pace-forms-drop-down-options-functional-element
    *ngIf="isDropDownOptionsFunctionalElement$ | async"
    [parentForm]="parentForm"
    [id]="id"
></pace-forms-drop-down-options-functional-element>
<pace-forms-discrepancy-log
    *ngIf="isDiscrepancyLog$ | async"
    [parentForm]="parentForm"
    [id]="id"
></pace-forms-discrepancy-log>
<pace-forms-material-serial-number
    *ngIf="isMaterialSerialNumber$ | async"
    [parentForm]="parentForm"
    [id]="id"
></pace-forms-material-serial-number>
<pace-forms-date-performed
    *ngIf="isDatePerformed$ | async"
    [parentForm]="parentForm"
    [id]="id"
></pace-forms-date-performed>
<pace-forms-replacement-or-last-procedure-date
    *ngIf="isReplacementOrLastProcedureDate$ | async"
    [parentForm]="parentForm"
    [id]="id"
></pace-forms-replacement-or-last-procedure-date>
<pace-forms-signature *ngIf="isSignature$ | async" [parentForm]="parentForm" [id]="id"></pace-forms-signature>
<pace-forms-value *ngIf="isValue$ | async" [parentForm]="parentForm" [id]="id"></pace-forms-value>
<pace-forms-astoria-option
    *ngIf="isAstoriaOption$ | async"
    [parentForm]="parentForm"
    [id]="id"
></pace-forms-astoria-option>
<pace-forms-cosima-option
    *ngIf="isCosimaOption$ | async"
    [parentForm]="parentForm"
    [id]="id"
></pace-forms-cosima-option>
<pace-forms-defective-component-replacement
    *ngIf="isDefectiveComponentReplacement$ | async"
    [parentForm]="parentForm"
    [id]="id"
></pace-forms-defective-component-replacement>
